import request from '@/utils/request';

let bankApi = {
    // 消息列表
    getBankList(data, err) {
        return request._postBody('/shop/user/yxshopBank/bankList', data, err);
    },
    // 新增消息
    getAddBank(data, err) {
        return request._postBody('/shop/user/yxshopBank/addBank', data, err);
    },
    // 删除消息
    getDelBank(data, err) {
        return request._postBody('/shop/user/yxshopBank/delBank', data, err);
    },
}


export default bankApi;



// WEBPACK FOOTER //
// ./src/api/setting/bank.js